import { useParams } from 'react-router-dom';
import { useShowViewer } from '../../../hooks/useShowViewer';

import {
    ViewerRoot,
    Main,
    InfoPanel,
    AttrRow,
    Attr,
    DetailRow,
    DetailLabel,
    DetailVal,
    ProgressStrip,
    ProgressFill,
    WaitingOverlay,
} from './ShowViewer.styles';

function buildSerial(card) {
    if (card.cardPrintNumber != null && card.cardSupply != null)
        return `#${card.cardPrintNumber}/${card.cardSupply}`;
    if (card.cardSupply != null) return `/${card.cardSupply}`;
    return '—';
}

export default function ShowViewer() {
    const { hostUid, showId } = useParams();
    const { show, cards, isLoading } = useShowViewer(hostUid, showId);

    // Derive card
    const cardIndex = show?.currentCardIndex ?? 0;
    const card = cards[cardIndex] ?? null;
    const pct = cards.length > 0
        ? Math.round(((cardIndex + 1) / cards.length) * 100)
        : 0;

    const attrs = Array.isArray(card?.cardAttributes) ? card.cardAttributes : [];

    const row1 = card ? [
        { label: 'Series', val: card.series ?? '—' },
    ] : [];

    const serial = card?.cardSupply != null ? buildSerial(card) : null;
    const parallelVal = [card?.cardParallelName ?? 'Base', serial].filter(Boolean).join(' ');

    const row2 = card ? [
        { label: 'Card #',   val: card.cardNumber ? `#${card.cardNumber}` : '—' },
        { label: 'Parallel', val: parallelVal, highlight: card?.cardSupply != null },
    ] : [];

    return (
        <ViewerRoot>
            {(isLoading || !card) ? (
                <Main>
                    <WaitingOverlay>
                        {isLoading ? 'Loading...' : 'Waiting for host to start the show'}
                        <p>Pull Vault · Whatnot Show Display</p>
                    </WaitingOverlay>
                </Main>
            ) : (
                <Main>
                    <InfoPanel>
                        {attrs.length > 0 && (
                            <AttrRow>
                                {attrs.map((a, i) => (
                                    <Attr key={i} $accent={i === 0}>{a}</Attr>
                                ))}
                            </AttrRow>
                        )}

                        <DetailRow>
                            {row1.map((d) => (
                                <div key={d.label}>
                                    <DetailLabel>{d.label}</DetailLabel>
                                    <DetailVal $highlight={d.highlight}>{d.val}</DetailVal>
                                </div>
                            ))}
                        </DetailRow>

                        <DetailRow>
                            {row2.map((d) => (
                                <div key={d.label}>
                                    <DetailLabel>{d.label}</DetailLabel>
                                    <DetailVal $highlight={d.highlight}>{d.val}</DetailVal>
                                </div>
                            ))}
                        </DetailRow>
                    </InfoPanel>
                </Main>
            )}

            <ProgressStrip>
                <ProgressFill $pct={pct} />
            </ProgressStrip>
        </ViewerRoot>
    );
}
